import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: () => import("@/views/Index.vue"),
    },
    {
      path: '/index_list',
      name: 'index_list',
      component: () => import("@/components/Index/list.vue")
    },
    {
      path: '/index_details',
      name: 'index_details',
      component: () => import("@/components/Index/details.vue")
    },
    {
      path: "*", // 重定向页面地址
      redirect: "/",
    },
    {
      path: "/AboutUs", // 关于我们
      name: "AboutUs",
      component: () => import("@/views/AboutUs.vue"),
    },
    {
      path: "/SoftwareDownload", // 软件下载
      name: "SoftwareDownload",
      component: () => import("@/views/SoftwareDownload.vue"),
    },
    {
      path: "/AbroStore", // 爱宝商城
      name: "AbroStore",
      component: () => import("@/views/AbroStore.vue"),
    },
    {
      path: "/AbroClassroom", // 教学平台
      name: "AbroClassroom",
      component: () => import("@/views/AbroClassroom.vue"),
    },
    {
      path: "/JoinIn", // 合作加盟
      name: "JoinIn",
      component: () => import("@/views/JoinIn.vue"),
    },
  ],
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0,
    };
  },
  // scrollBehavior: () => {
  //     history.pushState(null, null, document.URL)
  // }
});
